import { EWinPresentationStates } from '@Core/Win/States/WinPresentationStates';
import { EGameStates } from '@Managers/StateManager/GameStates';
import EventEmitter from 'eventemitter3';
import { EButtonEvents } from './ButtonEvents';
import { EGameEvents, isWildcardEvent } from './GameEvents';

export interface IEventData {
    eventName?: EGameEvents | EGameStates | EWinPresentationStates | EButtonEvents;
    eventIds?: number[];
    [key: string]: any;
}

export interface IWildcardEventData extends IEventData {
    eventIds: number[];
}

export class CustomEventsCenter extends EventEmitter {
    emit(event: string | symbol, data?: IEventData): boolean {
        if (typeof event === 'string' && isWildcardEvent(event)) {
            if (!data?.eventIds?.length) {
                throw new Error(`Event "${event}" expects at least one event id.`);
            }
        }

        return super.emit(event, { eventName: event, eventIds: data?.eventIds, ...data });
    }

    public waitForEvent(eventName: EGameEvents | EGameStates | EWinPresentationStates | EButtonEvents, ...ids: number[]): Promise<IEventData> {
        return new Promise((resolve) => {
            const handler = (data: IEventData) => {
                if (ids.length > 0) {
                    const { eventIds = [] } = data;
                    for (let i = 0; i < ids.length; i++) {
                        if (eventIds[i] !== ids[i]) {
                            return;
                        }
                    }
                }

                EventsCenter.off(eventName, handler, this);
                resolve({ ...data, eventName });
            };
            EventsCenter.on(eventName, handler, this);
        });
    }
}

const EventsCenter = new CustomEventsCenter();

export default EventsCenter;
